module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesRomantic@2x.e8b0565.webp";